import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const netography = defineConnector({
  identifier: "netography",
  name: "Netography",
  tagLine: "Network security analytics",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.netography\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create a JWT bearer token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://docs.netography.com/reference/v1_api_keys_appname_get](https://docs.netography.com/reference/v1_api_keys_appname_get) to create and use a JWT bearer token for the Netography API.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "JWT bearer token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.netography.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api.netography.com/")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
